import { useState, useCallback } from 'react';

interface AccordionHook {
  isActive: (index: number) => boolean;
  accordionOnClick: (index: number) => void;
}

export function useAccordion(): AccordionHook {
  const [activeIndex, setActiveIndex] = useState(-1);

  const isActive = useCallback(
    (index: number): boolean => index === activeIndex,
    [activeIndex],
  );

  const accordionOnClick = useCallback(
    (index: number): void => {
      setActiveIndex((prev) => (index === prev ? -1 : index));
    },
    [],
  );

  return { isActive, accordionOnClick };
}
